
<div class="summary-container" *ngIf="upgradeResource?.model$ | async as resource">
    <span class="summary">
        <span class="topic" i18n="@@operating.upgrade.summary.applicationsetname">Application set:</span>
        <span test-id="operating.upgrade.text.applicationsetname">{{resource.applicationSetName}}</span>
    </span>
    <span class="summary">
        <span class="topic" i18n="@@operating.upgrade.summary.applicationsetversion">Version:</span>
        <span test-id="operating.upgrade.text.applicationsetversion">{{resource.applicationSetVersion}}</span>
    </span>
</div>

<clx-accordion *ngIf="upgradeResource?.model$ | async as resource">
    <clx-accordion-item i18n-topic="@@operating.upgrade.accordion.text.files" topic="Files" state="opened" test-id="operatingupgrade.expander.files">
        <h3 class="clx-table-topic" i18n="@@operating.upgrade.table.topic.application-set-files">Application Set files</h3>
        <table class="clx-table" test-id="operatingupgrade.container.applicationsetdata">
            <thead>
                <th i18n="@@operating.upgrade.file-table.topic.type">Type</th>
                <th i18n="@@operating.upgrade.file-table.topic.device">Device</th>
                <th class="local-column" i18n="@@operating.upgrade.file-table.topic.local-loaded">Local Loaded</th>
                <th i18n="@@operating.upgrade.file-table.topic.application-set">Application set</th>
                <th class="actions-column" i18n="@@operating.upgrade.file-table.topic.actions">Actions</th>
            </thead>
            <tbody class="with-borders">
                <ng-container *ngFor="let siteFile of resource.siteFiles">
                    <tr has="important-text">
                        <td class="device-name">{{siteFile.deviceFriendlyName || siteFile.deviceName}}</td>
                        <td [class]="getVersionCellStyle(siteFile)">{{(siteFile.versionDevice) ? 'V ' + siteFile.versionDevice : '---' }}</td>
                        <td [class]="getLocalCellStyle(siteFile)">
                            <span *ngIf="!siteFile.uuidFile" i18n="@@operating.upgrade.file-state.not-stored">Not stored</span>
                            <span *ngIf="siteFile.uuidFile && siteFile.versionFile">V {{siteFile.versionFile}}</span>
                            <span *ngIf="siteFile.uuidFile && !siteFile.versionFile && siteFile.versionDevice" i18n="@@upgrade.version-unkown">V --.--</span>
                            <span *ngIf="siteFile.uuidFile && !siteFile.versionFile && !siteFile.versionDevice" i18n="@@upgrade.version-not-available">---</span>
                        </td>
                        <td [class]="(siteFile.associatedFile) ? 'inverted-font-color dark-grey-background' : 'grey-background'">
                            <span *ngIf="siteFile.associatedFile">V {{siteFile.associatedFile.version}}</span>
                            <span *ngIf="!siteFile.associatedFile" i18n="@@operating.upgrade.file-state.no-file-available">No file available</span>
                        </td>
                        <td>
                        <clx-button
                            *ngIf="siteFile.canBeUploadedFromDevice"
                            type="icon"
                            class="fa fa-cloud-upload"
                            (click)="upgradeService.getDownloadFileAction(siteFile).exec()"
                            [test-id]="'operatingupgrade.sitefile.' + getTestName(siteFile) + '.button.download'"
                            i18n-title="@@operatingupgrade.sitefile.button.download.title"
                            has-privileges="PlantUpgradeExpert"
                            title="upload from controller"
                        ></clx-button>
                            <clx-button
                                *ngIf="siteFile.associatedFile"
                                type="icon"
                                class="fa fa-save"
                                (click)="downloadFile(siteFile)"
                                [test-id]="'operatingupgrade.sitefile.' + getTestName(siteFile) + '.button.download'"
                                i18n-title="@@operatingupgrade.sitefile.button.save.title"
                                title="save"
                            ></clx-button>
                            <clx-button
                                *ngIf="siteFile.associatedFile"
                                type="icon"
                                class="fa fa-share-square"
                                (click)="upgradeService.getSendFileAction(siteFile).exec()"
                                [test-id]="'operatingupgrade.sitefile.' + getTestName(siteFile) + '.button.upload'"
                                i18n-title="@@operatingupgrade.sitefile.button.send.title"
                                has-privileges="PlantUpgradeExpert"
                                title="send to controller"
                            ></clx-button>
                        </td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>
                            <span has="small-text" *ngIf="!hasEmptyGuid(siteFile.uuidDevice)" [attr.test-id]="'operatingupgrade.sitefile.' + getTestName(siteFile) + '.guid.device'">{{siteFile.uuidDevice}}</span>
                        </td>
                        <td>
                            <span has="small-text" *ngIf="!hasEmptyGuid(siteFile.uuidFile)" [attr.test-id]="'operatingupgrade.sitefile.' + getTestName(siteFile) + '.guid.local-loaded'">{{(hasEmptyGuid(siteFile.uuidFile)) ? '---' : siteFile.uuidFile}}</span>
                        </td>
                        <td>
                            <span has="small-text" *ngIf="siteFile.associatedFile && siteFile.associatedFile.fileUuid" [attr.test-id]="'operatingupgrade.sitefile.' + getTestName(siteFile) + '.guid.application-set'">{{(hasEmptyGuid(siteFile.associatedFile.fileUuid)) ? '---' : siteFile.associatedFile.fileUuid}}</span>
                        </td>
                        <td>
                            <span
                                [attr.test-id]="'operatingupgrade.sitefile.' + getTestName(siteFile) + '.command-result'"
                                *ngIf="upgradeService.getDownloadFileAction(siteFile).commandResult$ | async as commandResult"
                                [class]="(upgradeService.getDownloadFileAction(siteFile).commandResult$ | async)?.status === 0 ? 'success-color' : (upgradeService.getDownloadFileAction(siteFile).commandResult$ | async)?.status === 4 ? 'error-color' : null"
                            >
                                {{getStateText(commandResult, upgradeService.getDownloadFileAction(siteFile).commandId)}}
                            </span>
                            <span
                                [attr.test-id]="'operatingupgrade.sitefile.' + getTestName(siteFile) + '.command-result'"
                                *ngIf="upgradeService.getSendFileAction(siteFile).commandResult$ | async as commandResult"
                                [class]="(upgradeService.getSendFileAction(siteFile).commandResult$ | async)?.status === 0 ? 'success-color' : (upgradeService.getSendFileAction(siteFile).commandResult$ | async)?.status === 4 ? 'error-color' : null"
                            >
                                {{getStateText(commandResult, upgradeService.getSendFileAction(siteFile).commandId)}}
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="5"></td>
                    </tr>
                </ng-container>

                <tr *ngIf="resource.upgradePriority > 1 && resource.releaseNotesFile">
                    <td class="important-text" i18n="@@operatingupgrade.releasenotes" >Release notes</td>
                    <td></td>
                    <td>
                      
                    </td>
                    <td has="right-aligment">
                        <span
                            is="releasnotes-uprade-status-icon"
                            class="icon-link fa fa-info-circle" 
                            has="big-icon green-icon-color"
                            *ngIf="resource.upgradePriority === 2"
                            title="New features"
                            i18n-title="@@operatingupgrade.green-newfeatures-status"
                        ></span>
                        <span
                            is="releasnotes-uprade-status-icon"
                            class="icon-link fa fa-info-circle" 
                            has="big-icon red-icon-color"
                            *ngIf="resource.upgradePriority === 4"
                            title="Security fixes"
                            i18n-title="@@operatingupgrade.red-securityfixes-status"
                        ></span>
                        <span
                            is="releasnotes-uprade-status-icon"
                            class="icon-link fa fa-info-circle" 
                            has="big-icon yellow-icon-color"
                            *ngIf="resource.upgradePriority === 3"
                            title="Bugfix"
                            i18n-title="@@operatingupgrade.yellow-bugfix-status"
                        ></span>
                    </td>
                    <td>
                        <clx-button
                            type="icon"
                            class="fa fa-download"
                            i18n-title="@@operatingupgrade.sitefile.button.download.title"
                            title="Download"
                            (click)="download(resource?.releaseNotesFile?.id)"
                        ></clx-button>
                        <clx-button
                            is="acknowledge-button"
                            #acknowledgeButton
                            (click)="acknowledgeReleasNotes()"
                            i18n="@@operatingupgrade.sitefile.button.achnowledgenotification.title"
                        >Acknowledge notification</clx-button>
                    </td>
                </tr>
            </tbody>
        </table>

        <clx-row type="buttons">
            <clx-button
                (onClick)="upgradeDialog.open()"
                [disabled]="upgradeButtonState" 
                test-id="operatingupgrade.button.startupgradeprocess"
                i18n="@@operating.upgrade.button.startupgradeprocess"
            >Start Upgrade</clx-button>
            <upgrade-configuration [resource]="resource" #upgradeDialog></upgrade-configuration>
        </clx-row>

        <h3 class="clx-table-topic" i18n="@@operating.upgrade.table.topic.site-files">Site files</h3>
        <table class="clx-table">
            <thead>
                <th i18n="@@operating.upgrade.table.topic.site-files.title.type">Type</th>
                <th i18n="@@operating.upgrade.table.topic.site-files.title.create-site-files">Created site files</th>
                <th class="actions-column" i18n="@@operating.upgrade.table.topic.site-files.title.actions">Actions</th>
            </thead>
            <tbody class="with-borders">
                <tr *ngIf="(resource.parameterFileNames && resource.parameterFileNames.length) || resource.applicationSetParameterFile
                    || (resource.backupFiles && resource.backupFiles.length) || (resource.backupPersistentFiles && resource.backupPersistentFiles.length)">
                    <td has="important-text" i18n="@@operating.upgrade.table.topic.site-files.title.parameters">Parameters</td>
                    <td>
                        <clx-custom-select #parameterSelect [selectionTitle]="resource.parameterFileUuid ? useApplicationSetText : chooseFileText" test-id="operatingupgrade.input.parameterfilesselection">
                            <parameter-window #parameter [selector]="parameterSelect" [data]="resource" test-id="operatingupgrade.popup.parameterfileselector"></parameter-window>
                        </clx-custom-select>
                    </td>
                    <td>
                        <clx-button
                            type="icon"
                            class="fa fa-save"
                            (click)="download('parameter')"
                            test-id="operatingupgrade.parameterfile.button.download"
                            title="save"
                            i18n-title="@@operatingupgrade.parameterfile.button.save.title"
                        ></clx-button>
                        <clx-button
                            type="icon"
                            class="fa fa-share-square"
                            title="send to controller"
                            i18n-title="@@operatingupgrade.parameterfile.button.send.title"
                            test-id="operatingupgrade.parameterfile.button.sendtoplantcontroller"
                            (onClick)="upgradeService.parameterFileAction(parameter, 'parameter').exec()"
                            [disabled]="(upgradeService.parameterFileAction(parameter, 'parameter').commandResult$ | async)?.status === 5 ? 'true' : null"
                            has-privileges="PlantUpgradeExpert"
                        ></clx-button>
                    </td>
                </tr>
                <tr *ngIf="(resource.parameterFileNames && resource.parameterFileNames.length) || resource.applicationSetParameterFile
                    || (resource.backupFiles && resource.backupFiles.length) || (resource.backupPersistentFiles && resource.backupPersistentFiles.length)">
                    <td></td>
                    <td colspan="2" class="right-aligned">
                        <span
                            test-id="operating.upgrade.plantfiles.text.actionstatus"
                            *ngIf="upgradeService.parameterFileAction(parameter, 'parameter').commandResult$ | async as commandResult"
                            [class]="(upgradeService.parameterFileAction(parameter, 'parameter').commandResult$ | async)?.status === 0 ? 'success-color' : (upgradeService.parameterFileAction(parameter, 'parameter').commandResult$ | async)?.status === 4 ? 'error-color' : null"
                        >
                            {{getStateText(commandResult, upgradeService.parameterFileAction(parameter, 'parameter').commandId)}}
                        </span>
                    </td>
                </tr>
                <tr *ngIf="(resource.bacnetFiles && resource.bacnetFiles.length) || resource.applicationSetBacnetFile">
                    <td has="important-text" i18n="@@operating.upgrade.table.topic.site-files.title.bacnet">BACnet</td>
                    <td>
                        <clx-custom-select #bacnetSelect [selectionTitle]="resource.bacnetFileUuid ? useApplicationSetText : chooseFileText" test-id="operatingupgrade.input.bacnetfilesselection">
                            <bacnet-parameter-window #bacnetParameter [selector]="bacnetSelect" [data]="resource" [addCurrentEntry]="false"  test-id="operatingupgrade.popup.bacnetfileselector"></bacnet-parameter-window>
                        </clx-custom-select>
                    </td>
                    <td>
                        <clx-button
                            type="icon"
                            class="fa fa-save"
                            (click)="download('bacnetParameter')"
                            test-id="operatingupgrade.bacnetfile.button.download"
                            title="save"
                            i18n-title="@@operatingupgrade.bacnetfile.button.save.title"
                        ></clx-button>
                        <clx-button
                            type="icon"
                            class="fa fa-share-square"
                            title="send to controller"
                            i18n-title="@@operatingupgrade.bacnetfile.button.sendtoplantcontroller.title"
                            test-id="operatingupgrade.bacnetfile.button.sendtoplantcontroller"
                            (onClick)="upgradeService.parameterFileAction(bacnetParameter, 'bacnetParameter').exec()"
                            [disabled]="(upgradeService.parameterFileAction(bacnetParameter, 'bacnetParameter').commandResult$ | async)?.status === 5 ? 'true' : null"
                            has-privileges="PlantUpgradeExpert"
                        ></clx-button>
                    </td>
                </tr>
                <tr *ngIf="(resource.bacnetFiles && resource.bacnetFiles.length) || resource.applicationSetBacnetFile">
                    <td></td>
                    <td colspan="2" class="right-aligned">
                        <span
                            test-id="operating.upgrade.bacnetfile.text.actionstatus"
                            *ngIf="bacnetParameter && upgradeService.parameterFileAction(bacnetParameter, 'bacnetParameter').commandResult$ | async as commandResult"
                            [class]="(upgradeService.parameterFileAction(bacnetParameter, 'bacnetParameter').commandResult$ | async)?.status === 0 ? 'success-color' : (upgradeService.parameterFileAction(bacnetParameter, 'bacnetParameter').commandResult$ | async)?.status === 4 ? 'error-color' : null"
                        >
                            {{getStateText(commandResult, upgradeService.parameterFileAction(bacnetParameter, 'bacnetParameter').commandId)}}
                        </span>
                    </td>
                </tr>
                <tr *ngIf="resource.ctrlTraceFiles && resource.ctrlTraceFiles.length">
                    <td has="important-text" i18n="@@operating.upgrade.table.topic.site-files.title.controller-protocol">Controller-protocol</td>
                    <td>
                        <clx-select #ctrl [values]="resource.traceSelect" test-id="operatingupgrade.select.controller-protocol"></clx-select>
                    </td>
                    <td>
                        <clx-button
                            type="icon"
                            class="fa fa-save" 
                            (click)="download(ctrl.value)"
                            test-id="operatingupgrade.controller-protocol.button.download"
                            title="download"
                            i18n-title="@@operatingupgrade.controller-protocol.button.download.title"
                        ></clx-button>
                    </td>
                </tr>
            </tbody>
        </table>
    </clx-accordion-item>
    <clx-accordion-item i18n-topic="@@operating.upgrade.accordion.text.online-actions" topic="Online actions" test-id="operatingupgrade.expander.onlineactions" has-privileges="PlantUpgradeExpert">
        <h3 class="clx-table-topic" i18n="@@operating.upgrade.table.topic.site-files">Site files</h3>
        <table class="clx-table online-actions">
            <thead>
                <th i18n="@@operating.upgrade.table.topic.site-files.title.command-progress">Command progress</th>
                <th i18n="@@operating.upgrade.table.topic.site-files.title.command" class="command-column">Command</th>
            </thead>
            <tbody class="with-borders">
                <tr *ngFor="let action of actions">
                    <td [class]="action.styleClass">
                        <span
                            *ngIf="action.commandResult$ | async as commandResult"
                            [attr.test-id]="action.testIdLabel"
                            [class]="(action.commandResult$ | async)?.status === 0 ? 'success-color' : (action.commandResult$ | async)?.status === 4 ? 'error-color' : null"
                        >
                            {{getStateText(commandResult, action.commandId)}}
                        </span>
                    </td>
                    <td class="right-aligned">
                        <clx-button
                            [state]="(action.commandResult$ | async)?.status === 5 ? 'loading' : null"
                            [test-id]="action.testIdButton"
                            (click)="resetStateTexts(); action.exec()"
                        >{{action.buttonText}}</clx-button>
                    </td>
                </tr>
            </tbody>
        </table>
    </clx-accordion-item>
</clx-accordion>